import React from 'react';
import { string } from 'prop-types';
import { useHelmet, TitleTag, MetaTag, LinkTag } from '@thd-nucleus/thd-helmet';
import { useDataModel,
  params as queryParams,
  shape as shapeType,
  string as stringType } from '@thd-nucleus/data-sources';

const HD_URL = 'https://www.homedepot.com';

const getStateDirectoryTitle = (name) => {
  return `The Home Depot Store Directory - ${name}`;
};

const getStateName = (data) => {
  const { stateName } = data?.storeDirectoryByState || {};
  return stateName;
};

const getMetaDescription = (stateName) => {
  if (stateName) {
    // eslint-disable-next-line max-len
    return `The Home Depot in ${stateName} is here to help with your home improvement needs. Stop by at one of our ${stateName} locations today.`;
  }
  return '';
};
const storeDirectoryHandler = ({ data, props }) => {

  const stateName = getStateName(data);
  const stateDirectoryTitle = getStateDirectoryTitle(stateName);
  const metaDescription = getMetaDescription(stateName);

  const tags = [];
  tags.push(new TitleTag(stateDirectoryTitle));
  tags.push(new MetaTag({ name: 'description', content: metaDescription, id: 'description' }));
  tags.push(new LinkTag({ rel: 'canonical', href: `${HD_URL}/l/${props}`, id: 'canonical' }));

  return tags;

};

const StateDirectoryMetadata = ({ state }) => {
  // /l/TX
  const options = {
    variables: {
      state
    }
  };
  const { data, loading, error } = useDataModel('storeDirectoryByState', options);
  const deps = data?.storeDirectoryByState && data?.storeDirectoryByState.stateName;
  useHelmet('stateDirectoryMetadata', { data, props: state }, storeDirectoryHandler, [deps]);
  return null;
};

StateDirectoryMetadata.dataModel = {
  storeDirectoryByState: queryParams({ state: stringType().isRequired() }).shape({
    stateName: stringType()
  })
};

StateDirectoryMetadata.propTypes = {
  state: string
};

StateDirectoryMetadata.defaultProps = {
  state: ''
};

export { StateDirectoryMetadata };
